import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-308">
      {children}
    </motion.div>;
};
export const StaggerContainer = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} variants={{
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  }} className={className} data-id="element-309">
      {children}
    </motion.div>;
};
export const StaggerItem = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  }} className={className} data-id="element-310">
      {children}
    </motion.div>;
};
export const Button = ({
  children,
  onClick,
  className = '',
  fullWidth = false,
  href = '#precio'
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (href.startsWith('http')) {
      window.open(href, '_blank');
    } else {
      const id = href.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-coral hover:bg-coral-hover text-white font-bold py-4 px-8 rounded-full 
        shadow-lg shadow-coral/20 transition-colors flex items-center justify-center gap-3
        text-lg md:text-xl cursor-pointer
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-311">
      {children}
      <ArrowRight className="w-5 h-5" data-id="element-312" />
    </motion.button>;
};
export const Section = ({
  children,
  className = '',
  bg = 'bg-cream-light',
  id
}: {
  children: ReactNode;
  className?: string;
  bg?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-12 md:py-20 px-6 ${bg} ${className}`} data-id="element-313">
      <div className="max-w-5xl mx-auto" data-id="element-314">{children}</div>
    </section>;
};